import DetailsHeaderAdminActions from '@/components/modals/workflowLogsModal/detailsHeader/DetailsHeaderAdminActions';
import StatusMarker from '@/components/modals/workflowLogsModal/StatusMarker';
import Skeleton from '@/components/Skeleton';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import setQuery from '@/lib/setQuery';
import { ReplayButton } from '@/screens/workflows/workflowLogs/ReplayButton';
import getReplayRunLabel from '@/screens/workflows/workflowLogs/lib/getReplayRunLabel';
import { format, formatDistanceToNow } from 'date-fns';
import { useSelector } from 'react-redux';

const DetailsHeader = () => {
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const log = useArgSelector(selectors.workflowLogsById, activeLogId);
  const isLoadingLogById = useArgSelector(selectors.isLoading, 'getWorkflowLogById');
  const isAdmin = useSelector((state) => selectors.user(state)?.jwt?.admin);
  const replaySourceLog = useArgSelector(selectors.workflowLogsById, log?.meta?.replay?.workflowLogId);
  const replaySourceLabel = replaySourceLog?.startedOn ? `↩ Replayed from ${format(new Date(replaySourceLog.startedOn), 'MMM d, h:mm a')} run` : '↩ Replayed from a previous run';

  let timeAgo = log?.startedOn ? formatDistanceToNow(new Date(log?.startedOn))?.replace('minutes', 'mins')?.replace('hours', 'hrs') + ' ago' : null;
  timeAgo = timeAgo?.[0]?.toUpperCase() + timeAgo?.slice(1);

  if (isLoadingLogById) {
    return (
      <div className="details-header">
        <Skeleton skeletonStyle={{ width: 300, height: 16, borderRadius: 6 }} containerStyle={{ padding: 0 }} />
      </div>
    );
  }

  return (
    <div className="details-header">
      <StatusMarker log={log} />
      <h2>{getReplayRunLabel(log) || log?.summary}</h2>
      {timeAgo && <span>{timeAgo}</span>}
      {log?.meta?.replay?.workflowLogId && (
        <span className="replay-source-link" data-title={'This run replayed actions from a previous run. Click to open the source run.'} onClick={() => setQuery({ logId: log.meta.replay.workflowLogId, time: 0, logStepId: null })}>
          {replaySourceLabel}
        </span>
      )}
      <span className="spacer" />
      <ReplayButton />
      {isAdmin && <DetailsHeaderAdminActions />}
    </div>
  );
};

export default DetailsHeader;
